module.exports = __webpack_public_path__ + "static/valvulas-gas-6529e413360b758fe75b944174d698d5.png";